<template>
  <v-navigation-drawer app v-model="drawer" style="height: 100%">
    <v-list dense class="py-0">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-list-item two-line class="px-2" v-on="on" v-bind="attrs">
            <v-list-item-avatar>
              <v-icon>mdi-account-circle</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ fullName }}</v-list-item-title>
              <v-list-item-subtitle>{{ email }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>

        <UserContextMenu />
      </v-menu>

      <v-divider />

      <v-list-item-group active-class="primary--text text--accent-4">
        <v-list-item to="/" v-if="hasAccess(['REGISTER_CROWDED_TRAIN'])">
          <v-list-item-title>Fullt tåg</v-list-item-title>
        </v-list-item>
        <v-list-item
          to="/staff-deviation"
          v-if="hasAccess(['REGISTER_STAFF_DEVIATION'])"
        >
          <v-list-item-title>Bemanning</v-list-item-title>
        </v-list-item>
        <v-list-item to="/cleaning" v-if="hasAccess(['REGISTER_CLEANING'])">
          <v-list-item-title>Vändstäd</v-list-item-title>
        </v-list-item>
        <template
          v-if="hasAccess(['MASTERDATA_USER', 'MASTERDATA_DEFINITION'])"
        >
          <v-subheader>Administratör</v-subheader>
          <v-list-item
            v-if="hasAccess(['MASTERDATA_USER'])"
            to="/masterdata/users"
          >
            <v-list-item-title>Användare</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="hasAccess(['MASTERDATA_DEFINITION'])"
            to="/masterdata/definitions"
          >
            <v-list-item-title>Definitioner</v-list-item-title>
          </v-list-item>
        </template>
        <template
          v-if="
            hasAccess([
              'MONITORING_CROWDED_TRAIN',
              'MONITORING_STAFF_DEVIATION'
            ])
          "
        >
          <v-subheader>Uppföljning</v-subheader>
          <v-list-item
            to="/monitoring/crowded-train-registrations"
            v-if="hasAccess(['MONITORING_CROWDED_TRAIN'])"
          >
            <v-list-item-title>Fullt tåg registreringar</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/monitoring/staff-deviation-registrations"
            v-if="hasAccess(['MONITORING_STAFF_DEVIATION'])"
          >
            <v-list-item-title>Bemannings avvikelser</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/monitoring/cleaning"
            v-if="hasAccess(['MONITORING_CLEANING'])"
          >
            <v-list-item-title>Vändstäd</v-list-item-title>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
    <template v-slot:append>
      <v-btn block tile @click="onLogout">
        <v-icon small left>mdi-exit-to-app</v-icon>
        Logga ut
      </v-btn>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { sync, get } from 'vuex-pathify'
import UserContextMenu from './UserContextMenu'

export default {
  name: 'AppNavigationDrawer',

  components: {
    UserContextMenu
  },

  computed: {
    ...get('user', ['fullName', 'data.email', 'hasAccess']),
    drawer: sync('app/drawer')
  },

  methods: {
    onLogout() {
      this.$store.dispatch('user/logout')
    }
  }
}
</script>
